module.exports = __webpack_public_path__ + "static/sport/game-2.08c56e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/game-2.png
// module id = w9gM
// module chunks = 0